import { Controller } from 'stimulus';

// Renders a framed table's "Clear sorting & filters" and "Download CSV" buttons
// in the page shell, inline with the heading that sits outside the table's
// turbo frame, and bridges to the in-frame tabulator-table controller via
// window events (mirrors the cross-frame `compare:*` pattern). The Clear button
// shows only while the table has an active sort/filter, reported by the table
// through `tabulator-table:state`; clicking it dispatches `tabulator-table:clear`
// and Download CSV dispatches `tabulator-table:download-csv`.
export default class extends Controller {
  static targets = ['clear'];
  static values = { frame: String };

  connect() {
    this.onState = this.onState.bind(this);
    window.addEventListener('tabulator-table:state', this.onState);
  }

  disconnect() {
    window.removeEventListener('tabulator-table:state', this.onState);
  }

  onState(event) {
    if (event.detail?.frame !== this.frameValue) return;
    if (this.hasClearTarget) this.clearTarget.hidden = !event.detail.active;
  }

  clear() {
    window.dispatchEvent(
      new CustomEvent('tabulator-table:clear', {
        detail: { frame: this.frameValue },
      })
    );
  }

  downloadCsv() {
    window.dispatchEvent(
      new CustomEvent('tabulator-table:download-csv', {
        detail: { frame: this.frameValue },
      })
    );
  }
}
